__turbopack_context__.v({
  "errorMessageText": "SearchBar-module-scss-module__wtKxna__errorMessageText",
  "noSearchIcon": "SearchBar-module-scss-module__wtKxna__noSearchIcon",
  "searchInputContainer": "SearchBar-module-scss-module__wtKxna__searchInputContainer",
  "searchInputWrapper": "SearchBar-module-scss-module__wtKxna__searchInputWrapper",
  "selectedOptionWrapper": "SearchBar-module-scss-module__wtKxna__selectedOptionWrapper",
});
